import { render } from "./AssignmentCard.vue?vue&type=template&id=9f87298c&scoped=true"
import script from "./AssignmentCard.vue?vue&type=script&lang=js"
export * from "./AssignmentCard.vue?vue&type=script&lang=js"

import "./AssignmentCard.vue?vue&type=style&index=0&id=9f87298c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f87298c"]])

export default __exports__